if (!customElements.get('dc-account-menu')) {
  class DelmicureAccountMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.outside = (event) => { if (!this.contains(event.target)) this.details.open = false; };
      this.escape = (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.summary.focus();
          event.stopPropagation();
        }
      };
      this.focusLeave = (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false; };
      document.addEventListener('pointerdown', this.outside);
      this.addEventListener('keydown', this.escape);
      this.addEventListener('focusout', this.focusLeave);
    }
    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.outside);
      this.removeEventListener('keydown', this.escape);
      this.removeEventListener('focusout', this.focusLeave);
    }
  }
  customElements.define('dc-account-menu', DelmicureAccountMenu);
}
